import React from 'react';
import { DropdownContainer } from './styled.dropdown';
import Select, { components } from 'react-select';
import { IDropdown } from '../../../@types/dropdown';
import { defaultTheme } from '../../../styles/theme/default';
import { CloseCircleDark } from './../../icons/CloseCircleDark';

export function DropdownSingle ({
  options,
  defaultOption,
  isSearchable = true,
  disabled = false,
  isClearable = true,
  callback,
  menuPlacement = 'auto',
  placeholder,
}: IDropdown) {
  const indentation = {
    category: '4px',
    subCategory: '16px',
  };

  const customStyles = {
    option: (provided, state) => {
      return {
        ...provided,
        paddingLeft: indentation[state.data.category],
        color: state.isSelected ? 'black' : 'black',
      };
    },
    menu: (provided) => ({ ...provided, zIndex: 10 }),
  };

  const CustomClearIndicator = (props) => {
    return (
      <>
        {isClearable && (
          <components.ClearIndicator {...props}>
            <CloseCircleDark />
          </components.ClearIndicator>
        )}
      </>
    );
  };

  return (
    <DropdownContainer data-testid="dropdown-single">
      <Select
        isSearchable={isSearchable}
        isClearable={true}
        menuPlacement={menuPlacement}
        value={defaultOption}
        options={options}
        isDisabled={disabled}
        onChange={(option) => {
          if (option && callback) {
            callback(option);
          } else if (callback) {
            callback('');
          }
        }}
        placeholder={placeholder}
        components={{ ClearIndicator: CustomClearIndicator }}
        styles={customStyles}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: defaultTheme.colorsInObjects.gray[200],
          },
        })}
        data-testid="dropdown-single-item"
      />
    </DropdownContainer>
  );
}
